import React from "react";
import { Trophy } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface CertificationsSectionProps {
  certifications: TransformedProfileData["sections"]["certifications"]["items"];
}

export const CertificationsSection: React.FC<CertificationsSectionProps> = ({
  certifications,
}) => {
  return (
    <Section
      id="certifications"
      title="Certifications"
      icon={<Trophy className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-2">
        {certifications
          .filter((cert) => cert.privacy.isVisible)
          .map((cert) => (
            <article key={cert.id} className="card-apple p-5">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold">{cert.name}</h3>
                  <div className="mt-1 text-sm text-secondary">
                    {cert.issuer}
                  </div>
                  <div className="mt-2 text-xs text-tertiary">
                    Issued: {new Date(cert.issueDate).toLocaleDateString()}
                    {cert.expirationDate && (
                      <span>
                        {" "}
                        • Expires:{" "}
                        {new Date(cert.expirationDate).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                </div>
                {cert.logo && (
                  <img
                    src={cert.logo}
                    alt={cert.issuer}
                    className="h-8 w-8 rounded object-contain"
                  />
                )}
              </div>
              {cert.credentialId && (
                <div className="mt-2 text-xs text-tertiary">
                  ID: {cert.credentialId}
                </div>
              )}
              {cert.credentialUrl && (
                <a
                  href={cert.credentialUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 inline-flex items-center gap-1 text-xs text-primary hover:underline"
                >
                  View Certificate
                </a>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
